import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getProfile = (payload, callback) =>
  req.item(c.GET_PROFILE, '/api/v1/administrators/profile', payload, callback);

export const updateProfile = (payload, callback) =>
  req.update(
    c.UPDATE_PROFILE,
    `/api/v1/administrators/profile`,
    payload,
    callback
  );

export const generate2fa = (payload, callback) =>
  req.create(
    c.GENERATE_2FA,
    '/api/v1/administrators/generate2faKey',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const enable2fa = (payload, callback) =>
  req.create(
    c.ENABLE_2FA,
    '/api/v1/administrators/enable2fa',
    payload,
    callback
  );

export const disable2fa = (payload, callback) =>
  req.create(
    c.DISABLE_2FA,
    '/api/v1/administrators/disable2fa',
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'You have successfully disabled your account.');
      if (callback) callback();
    }
  );

export const changePassword = (payload, callback) =>
  req.update(
    c.CHANGE_PASSWORD,
    '/api/v1/administrators/change_profile_password',
    payload,
    callback
  );

export const updateOtpSource = (payload, callback) =>
  req.create(
    c.UPDATE_OTP_SOURCE,
    '/api/v1/administrators/update_otp_source',
    payload,
    () => {
      if (callback) callback();
    }
  );
